export type VerticalPosition = "top" | "bottom";
export type HorizontalPosition = "left" | "center" | "right";

export interface PreviewCardPosition {
  verticalPosition?: VerticalPosition | null;
  horizontalPosition?: HorizontalPosition | null;
}

/**
 * Returns where to position preview card relative to marker's position on the map
 */
export const getPreviewCardPosition = (mapElement: Element, markerElement: Element, previewItemElement: Element): PreviewCardPosition => {
  const { top: mapDistanceToTop, left: mapDistanceToLeft, right: mapDistanceToRight } = mapElement.getBoundingClientRect();
  const { top: markerDistanceToTop, left: markerDistanceToLeft, right: markerDistanceToRight } = markerElement.getBoundingClientRect();
  const { width: previewCardWidth, height: previewCardHeight } = previewItemElement.getBoundingClientRect();

  // We get space available between marker and top of map
  const distanceToTop = Math.abs(mapDistanceToTop - markerDistanceToTop);

  // We get space available between marker and left edge of map
  const distanceToLeft = Math.abs(mapDistanceToLeft - markerDistanceToLeft);

  // We get space available between marker and right edge of map
  const distanceToRight = Math.abs(mapDistanceToRight - markerDistanceToRight);

  // When enough space on the left and right we center the preview card
  const enoughSpaceOnLeftToCenter = distanceToLeft >= previewCardWidth / 2;
  const enoughSpaceOnRightToCenter = distanceToRight >= previewCardWidth / 2;
  const canCenterPreviewCard = enoughSpaceOnLeftToCenter && enoughSpaceOnRightToCenter;

  return {
    verticalPosition: distanceToTop > previewCardHeight ? "top" : "bottom",
    horizontalPosition: canCenterPreviewCard ? "center" : distanceToLeft > previewCardWidth ? "left" : "right",
  };
};
